import { gql } from 'graphql-tag'
import queryPageFields from '../../../../core/data-layer/pages/page/query-page-fields'

export default gql`
  query ($slug: String!, $locale: String!, $preview: Boolean!) {
    page: pagePoliciesAndDisclaimerCollection(limit: 1, where: { slug: $slug }, locale: $locale, preview: $preview) {
      items {
        ${queryPageFields}
        itemsCollection {
          items {
            sys {
              id
            }
            title
            icon
            navigationTitle
          }
        }
      }
    }
  }
`
